import __request__ from 'routing/request';
interface Object {
}
interface CollectorAction {
    readonly collector_id: string;
    readonly properties: {
        readonly [_key: string]: Object;
    };
}
type CollectorActionArray = CollectorAction[];
/**
 * Returns queued actions for the specified Sidecar id
 */
export function getAction(sidecarId: string): Promise<CollectorActionArray> {
    return __request__('GET', `/sidecar/action/${sidecarId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Set a collector action
 * @param sidecarId The id this Sidecar is registering as.
 */
export function setAction(sidecarId: string, JSONbody: CollectorActionArray): Promise<unknown> {
    return __request__('PUT', `/sidecar/action/${sidecarId}`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
